
const initialState = false;
const initialStateColegio = {};
const initialUsuario = {};
const initialStateAnio = {};

export function loadingRedux(state = initialState, action) {
   
    switch (action.type) {
        case 'Loading':
            //return Object.assign({},state, {list: action.payload})
             state = action.payload;
           return state;
        default:
            return state 
    }
    
}

export function setUsuarioRedux(state = initialUsuario, action) {
   
    switch (action.type) {
        case 'setUsuario':
            //return Object.assign({},state, {list: action.payload})
             state = action.payload;
           return state;
        default:
            return state 
    }
}

export function selectAnioRedux(state = initialStateAnio, action) {
   
    switch (action.type) {
        case 'selectAnio':
            //return Object.assign({},state, {list: action.payload})
             state = action.payload;
           return state;
        default:
            return state 
    }
}

export function selectColegioRedux(state = initialStateColegio, action) {
   
    switch (action.type) {
        case 'selectColegio':
            //return Object.assign({},state, {list: action.payload})
             state = action.payload;
           return state;
        default:
            return state 
    }
}